import { useEffect, useState } from 'react';
import { Award, Download, Share2, Trophy, ShieldCheck, TrendingUp } from 'lucide-react';
import { certificatesAPI } from '@/lib/api';
import { formatMoney } from '@/lib/format';
import ShareCertModal from '@/components/ShareCertModal';

const TYPE_META = {
  payout:          { label: 'Performance Reward', icon: Trophy,      tint: '#00ff66' },
  phase_1_passed:  { label: 'Phase 1 Passed',     icon: ShieldCheck, tint: '#33ff85' },
  phase_2_passed:  { label: 'Phase 2 Passed',     icon: ShieldCheck, tint: '#33ff85' },
  funded:          { label: 'Performance Trader', icon: TrendingUp,  tint: '#00ff66' },
};

export default function Certificates() {
  const [certs, setCerts] = useState([]);
  const [shareCert, setShareCert] = useState(null);
  useEffect(() => { certificatesAPI.mine().then(setCerts); }, []);

  return (
    <div className="space-y-6">
      <div>
        <div className="label-sm mb-2">Certificates</div>
        <h1 className="font-display text-3xl">Achievements</h1>
        <p className="text-zinc-500 text-sm mt-1">Every milestone earns a signed Traders Spring certificate. Share yours anywhere.</p>
      </div>

      {certs.length === 0 ? (
        <div className="card-tech rounded-lg p-12 text-center">
          <Award size={30} className="text-[#00ff66] mx-auto" />
          <h3 className="font-display text-2xl mt-3">No certificates yet</h3>
          <p className="text-zinc-500 text-sm mt-1">Pass a phase or earn a payout to unlock your first achievement.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {certs.map(c => {
            const meta = TYPE_META[c.cert_type] || TYPE_META.payout;
            const Icon = meta.icon;
            return (
              <div key={c.certificate_id} className="card-tech rounded-lg overflow-hidden" data-testid={`cert-${c.certificate_id}`}>
                <div className="p-5 bg-gradient-to-br from-[#001a0d] to-black border-b border-white/5 relative">
                  <div className="flex items-center gap-2">
                    <Icon size={14} style={{ color: meta.tint }} />
                    <span className="label-xs">{meta.label.toUpperCase()}</span>
                  </div>
                  {c.cert_type === 'payout' ? (
                    <div className="font-display text-2xl mt-3">${formatMoney(c.amount)}</div>
                  ) : (
                    <div className="font-display text-xl mt-3">{c.plan_name || 'Traders Spring Program'}</div>
                  )}
                  {c.account_size && <div className="text-xs font-mono text-zinc-400 mt-1">${Number(c.account_size).toLocaleString()} account</div>}
                  <div className="text-xs text-zinc-500 mt-1 font-mono">{c.certificate_id.toUpperCase()}</div>
                </div>
                <div className="p-5 flex items-center justify-between gap-2">
                  <div className="text-xs text-zinc-500">{new Date(c.issued_at).toLocaleDateString()}</div>
                  <div className="flex gap-2">
                    <button className="btn-ghost btn-sm" onClick={() => certificatesAPI.download(c.certificate_id)} data-testid={`download-cert-${c.certificate_id}`}>
                      <Download size={12} className="inline mr-1" /> PDF
                    </button>
                    <button className="btn-primary btn-sm" onClick={() => setShareCert(c)} data-testid={`share-cert-${c.certificate_id}`}>
                      <Share2 size={12} /> Share
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {shareCert && <ShareCertModal cert={shareCert} onClose={() => setShareCert(null)} />}
    </div>
  );
}
